import { isMobile } from '@/lib/device'
// const devicePath = !isMobile ? 'pc' : 'mobile'

export default [
  {
    path: 'inquery/clue',
    name: 'InqueryClue',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-core" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-core" */ `@/pc/inquery/clue/ClueIndex`)
  },
  {
    path: 'clue/create',
    name: 'ClueCreate',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-core" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-core" */ `@/pc/inquery/create/ClueIndex`)
  },
  {
    path: 'inquery/create',
    name: 'InqueryCreate',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-core" */ `@/mobile/inquery/create/index`)
        : import(/* webpackChunkName: "pc-core" */ `@/pc/inquery/create/index`)
  },
  {
    path: 'inquery/audit',
    name: 'InqueryAudit',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-core" */ `@/mobile/inquery/audit/index`)
        : import(/* webpackChunkName: "pc-core" */ `@/pc/inquery/audit/index`)
  },
  {
    path: 'inquery/repeat',
    name: 'InqueryRepeat',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-core" */ `@/mobile/inquery/repeat/index`)
        : import(/* webpackChunkName: "pc-core" */ `@/pc/inquery/repeat/index`)
  },
  {
    path: 'inquery/list',
    name: 'InqueryList',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-core" */ `@/mobile/inquery/list/index`)
        : import(/* webpackChunkName: "pc-core" */ `@/pc/inquery/list/index`)
  },
  {
    path: 'inquery/detail/:inquiryId',
    name: 'InqueryDetail',
    props: true,
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-core" */ `@/mobile/inquery/detail/index`)
        : import(/* webpackChunkName: "pc-core" */ `@/pc/inquery/detail/index`)
  }
]
